import { DEFAULT_GROUP, gql } from "@edreamsodigeo/frontend-api-client";

export const PRICE_BREAKDOWN_TOTAL_PRICE = gql`
  query GetPriceBreakdownTotalPrice($request: PriceBreakDownRequest!) @update_groups(groups: "${DEFAULT_GROUP},addProductToShoppingBundle,removeProductFromShoppingBundle") {
    getCartPriceBreakDown(request: $request) {
      priceSummary {
        totalPrice {
          amount
          currency
        }
        discountedPrice {
          amount
          currency
        }
        nonDiscountedPrice {
          amount
          currency
        }
      }
    }
  }
`;
